import React, {
  Component,
} from 'react';
import generalClasses from '../../GeneralFormComponent/GeneralFormComponent.module.scss';
import DatePickerField from '../DatePickerField/DatePickerField';
import {
  IAutoScheduledField,
} from '../formFields';
import ToggleButtonField from '../ToggleButtonField/ToggleButtonField';
import classes from './AutoScheduledField.module.scss';

interface IProps extends IAutoScheduledField {
  errors: any;
  touched: any;

  onToggleChange(parentName: string, childName: string, value: boolean): any;

  onStartDateChange(parentName: string, childName: string, value: Date): any;

  onEndDateChange(parentName: string, childName: string, value: Date): any;
}

class AutoScheduledField extends Component<IProps> {
  render() {
    return (
      (this.props.value && this.props.value.toggle) ? (
        <div className={generalClasses.filed}>
          <ToggleButtonField
            onChange={(childName: string, value: boolean) => this.props.onToggleChange(this.props.name, 'toggle', value)}
            errors={this.props.errors}
            touched={this.props.touched}
            filedType={this.props.toggle.filedType}
            name={this.props.toggle.name}
            label={this.props.toggle.label}
            value={this.props.value.toggle}
            activeLabel={this.props.toggle.activeLabel}
            inactiveLabel={this.props.toggle.inactiveLabel}
          />
          <div className={classes.dateContainer}>
            <div className={classes.startDate}>
              <DatePickerField
                onChange={(childName: string, value: Date) => this.props.onStartDateChange(this.props.name, 'startDate', value)}
                errors={this.props.errors.autoScheduled ? this.props.errors.autoScheduled : {
                }}
                touched={this.props.errors.autoScheduled ? this.props.errors.autoScheduled : {
                }}
                filedType={this.props.startDate.filedType}
                name="startDate"
                minDate={this.props.startDate.minDate}
                label={this.props.startDate.label}
                value={this.props.value.startDate}
              />
            </div>
            <div className={classes.endDate}>
              <DatePickerField
                onChange={(childName: string, value: Date) => this.props.onEndDateChange(this.props.name, 'endDate', value)}
                errors={this.props.errors.autoScheduled ? this.props.errors.autoScheduled : {
                }}
                touched={this.props.errors.autoScheduled ? this.props.errors.autoScheduled : {
                }}
                filedType={this.props.endDate.filedType}
                name="endDate"
                minDate={this.props.value.startDate || this.props.endDate.minDate}
                label={this.props.endDate.label}
                value={this.props.value.endDate}
              />
            </div>
          </div>
        </div>
      ) : (
        <div>
          <ToggleButtonField
            onChange={(childName: string, value: boolean) => this.props.onToggleChange(this.props.name, 'toggle', value)}
            errors={this.props.errors}
            touched={this.props.touched}
            filedType={this.props.toggle.filedType}
            name={this.props.toggle.name}
            label={this.props.toggle.label}
            value={this.props.value!.toggle}
            activeLabel={this.props.toggle.activeLabel}
            inactiveLabel={this.props.toggle.inactiveLabel}
          />
        </div>
      )
    );
  }
}

export default AutoScheduledField;
